import TextField from "@mui/material/TextField";
import { ChangeEvent, useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import { MenuItem } from "@mui/material";

import { useSelector } from "react-redux";

import { Icon } from "@/components";

import {
	subTasksSelector,
	tasksSelector,
} from "@/pages/Private/redux/tasks-and-subtasks/tasks-and-subtasks.slice";

import { ToDoStatus } from "../enum/ToDoStatus.enum";
import { useToDoSocket } from "../providers/SocketContext";
import AssigneeModal from "../../../TasksAndSubTasks/components/AssigneeModal";

interface ToDoStatusDropDownProps {
	companyToDoProgressId: number;
	className?: string;
	isTask?: boolean;
}

export function ToDoStatusDropDown({
	companyToDoProgressId,
	className,
	isTask,
}: ToDoStatusDropDownProps) {
	const { t } = useTranslation();
	const ts = (key: string) => t(`to-do.${key}`);
	const { changeTaskStatus } = useToDoSocket();
	const tasks = useSelector(tasksSelector);
	const subtasks = useSelector(subTasksSelector);
	const [isAssigneeModalOpen, setIsAssigneeModalOpen] = useState(false);

	const data = useMemo(
		() =>
			isTask
				? tasks.find((item) => item.id === companyToDoProgressId)
				: subtasks.find((item) => item.id === companyToDoProgressId),
		[companyToDoProgressId, tasks, subtasks]
	);
	const onChange = useCallback(
		(e: ChangeEvent<HTMLInputElement>) => {
			if (e.target.value === ToDoStatus.QA) {
				setIsAssigneeModalOpen(true);
			} else {
				changeTaskStatus(companyToDoProgressId, e.target.value as ToDoStatus);
			}
		},
		[changeTaskStatus, companyToDoProgressId]
	);

	return (
		<>
			<h1 className="text-[16px] font-normal leading-5 text-primary-blue-dark mb-3">
				{ts(`${data?.status}`)}
			</h1>
			{/* <TextField
				select
				SelectProps={{
					renderValue: (selected) => <>{ts(`${selected}`)}</>,
					MenuProps: {
						PaperProps: {
							sx: {
								padding: "8px",
								width: "140px",
								marginTop: "0px",
								borderRadius: "12px",
								"& .MuiList-root": {
									margin: "0px",
									padding: "0px",
									gap: "8px",
									display: "flex",
									flexDirection: "column",
								},
								"& .MuiMenuItem-root": {
									display: "flex",
									alignItems: "center",
									justifyContent: "space-between",
									fontSize: "14px",
									margin: "0px",
									padding: "0px",
									backgroundColor: "transparent !important",
									"&.Mui-selected": {
										color: "#4680FC",
									},
									"&:hover": {
										backgroundColor: "transparent !important",
									},
								},
							},
						},
					},
				}}
				className={className}
				inputProps={{
					style: {
						display: "flex",
						alignItems: "center",
						fontSize: "14px",
					},
				}}
				sx={{
					"min-width": "160px",
					"& .MuiSelect-select": {
						alignSelf: "flex-end",
						padding: "8px",
						fontSize: "14px",
					},
					"& .MuiInputBase-root": {
						marginBottom: "0px",
						borderRadius: "12px",
						fontSize: "14px",
					},
					"& .MuiSelect-icon": {
						color: "#1D243C",
					},
				}}
				value={data?.status ?? ""}
				onChange={onChange}
			>
				{Object.values(ToDoStatus).map((status, index) => (
					<MenuItem key={index} value={status}>
						{ts(`${status}`)}
						{data?.status === status && <Icon className="ml-2 w-5 h-5" icon={faCheck} />}
					</MenuItem>
				))}
			</TextField> */}
			<AssigneeModal
				data={data ?? null}
				isOpen={isAssigneeModalOpen}
				setIsOpen={(val) => {
					setIsAssigneeModalOpen(val);
				}}
			/>
		</>
	);
}
